<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'OFWCA'" [name]="'Lista'"></app-breadcrumb>
<div class="ofwca-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="ofwca-list-filters">
    <mat-form-field class="ofwca-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Numer Profitowi</mat-label>
      <input matInput placeholder="12345" name="eq$profitNumber" [(ngModel)]="initialFilters.eq$profitNumber">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Imię</mat-label>
      <input matInput placeholder="Imię" name="contains$firstName" [(ngModel)]="initialFilters.contains$firstName">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Drugie imię</mat-label>
      <input matInput placeholder="Drugie imię" name="contains$secondName" [(ngModel)]="initialFilters.contains$secondName">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Nazwisko</mat-label>
      <input matInput placeholder="Nazwisko" name="contains$lastName" [(ngModel)]="initialFilters.contains$lastName">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Nazwisko rodowe</mat-label>
      <input matInput placeholder="Nazwisko rodowe" name="contains$familyName" [(ngModel)]="initialFilters.contains$familyName">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>PESEL</mat-label>
      <input matInput placeholder="PESEL" name="contains$pesel" [(ngModel)]="initialFilters.contains$pesel">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Numer dokumentu tożsamości</mat-label>
      <input matInput placeholder="Numer dokumentu tożsamości" name="contains$documentNumber" [(ngModel)]="initialFilters.contains$documentNumber">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" name="email" [(ngModel)]="initialFilters.email">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Numer telefonu</mat-label>
      <input matInput placeholder="Numer telefonu" name="contains$phone" [(ngModel)]="initialFilters.contains$phone">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter ofwca-list-filter-long">
      <mat-label>Adres</mat-label>
      <input matInput placeholder="Armii Krajowej 18, Siedlce 08-110" name="address" [(ngModel)]="initialFilters.address">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'address_state'"
      [label]="'Województwo'" class="ofwca-list-filter"
      [(ngModel)]="initialFilters.state" name="state"
    ></app-dict>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (majątek)'"
      class="ofwca-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (życie)'" class="ofwca-list-filter"
      [(ngModel)]="initialFilters.lifeRegional" name="lifeRegional"
    ></app-dict-regionals>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (majątek) Partnera'" class="ofwca-list-filter ofwca-list-filter-long"
      [(ngModel)]="initialFilters.partnerAssetsRegional" name="partnerAssetsRegional"
    ></app-dict-regionals>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="ofwca-list-filter ofwca-list-filter-long"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <mat-form-field class="ofwca-list-filter ofwca-list-filter-long">
      <mat-label>Adres placówki</mat-label>
      <input matInput placeholder="Armii Krajowej 18, Siedlce 08-110" name="facilityAddress" [(ngModel)]="initialFilters.facilityAddress">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'address_state'"
      [label]="'Województwo placówki'" class="ofwca-list-filter"
      [(ngModel)]="initialFilters.facilityState" name="facilityState"
    ></app-dict>

    <mat-form-field appearance="standard" class="ofwca-list-filter">
      <mat-label>Właściciel firmy</mat-label>
      <mat-select [(ngModel)]="initialFilters.owner" name="owner">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

<!--    <mat-form-field appearance="standard" class="ofwca-list-filter">-->
<!--      <mat-label>Rekord zweryfikowany</mat-label>-->
<!--      <mat-select [(ngModel)]="initialFilters.verified" name="verified">-->
<!--        <mat-option [value]="null">Wszyscy</mat-option>-->
<!--        <mat-option [value]="1">Tak</mat-option>-->
<!--        <mat-option [value]="0">Nie</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <app-dict
      class="ofwca-list-filter" [label]="'Tagi partnera'"
      [dictType]="'partner_tags'"
      [required]="false" [multiple]="true"
      [(ngModel)]="initialFilters.partnerTag" name="partnerTag"
    ></app-dict>

    <mat-form-field class="ofwca-list-filter">
      <mat-label>Numer RAU</mat-label>
      <input matInput placeholder="Numer RAU" name="rauNumber" [(ngModel)]="initialFilters.rauNumber">
    </mat-form-field>

    <app-dict
      [multiple]="true" [dictType]="'ofwca_status'"
      [required]="false"
      [label]="'Status'" class="ofwca-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <mat-form-field appearance="standard" class="ofwca-list-filter">
      <mat-label>Nadanie dostępu </mat-label>
      <mat-select [(ngModel)]="initialFilters.hiperioGrantingAccess" name="hiperioGrantingAccess">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="ofwca-list-filter">
      <mat-label>Automatyczna aktualizacja dostępów </mat-label>
      <mat-select [(ngModel)]="initialFilters.hiperioAutomaticAccessUpdate" name="hiperioAutomaticAccessUpdate">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="ofwca-list-filter">
      <mat-label>Podpisana umowa z pracownikiem</mat-label>
      <mat-select [(ngModel)]="initialFilters.signedContractWithTheEmployee" name="signedContractWithTheEmployee">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="ofwca-list-filter">
      <mat-label>Konto ASF360</mat-label>
      <mat-select [(ngModel)]="initialFilters.has360Account" name="has360Account">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <button *ngIf="rejectedCommission" (click)="addRejectedCommission()" mat-raised-button ><mat-icon>add</mat-icon> <span> Dodaj</span></button>

  <div class="ofwca-list-buttons">
    <button *ngIf="(userPermissions | async).ofwca_additional.read_report && !rejectedCommission" [disabled]="!(userPermissions | async).ofwca_additional?.read_report"
            mat-raised-button [matMenuTriggerFor]="generateRegional" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generateRegional="matMenu">
      <button *ngIf="(userPermissions | async).ofwca_additional.read_report" [disabled]="!(userPermissions | async).ofwca_additional?.read_report"  mat-menu-item (click)="downloadReportRegional()">Pobierz raport pełny</button>
      <button *ngIf="(userPermissions | async).ofwca_additional.read_report" [disabled]="!(userPermissions | async).ofwca_additional?.read_report" mat-menu-item (click)="openReportDialogRegional()">Pobierz raport niestandardowy</button>
    </mat-menu>

    <button *ngIf="(userPermissions | async).ofwca.read_report && !rejectedCommission" [disabled]="!(userPermissions | async).ofwca.read_report"
            mat-raised-button [matMenuTriggerFor]="generate" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generate="matMenu">
      <button *ngIf="(userPermissions | async).ofwca.read_report" [disabled]="!(userPermissions | async).ofwca.read_report"  mat-menu-item (click)="downloadReport()">Pobierz raport pełny</button>
      <button *ngIf="(userPermissions | async).ofwca.read_report" [disabled]="!(userPermissions | async).ofwca.read_report" mat-menu-item (click)="openReportDialog()">Pobierz raport niestandardowy</button>
      <button *ngIf="(userPermissions | async).ofwca.regional_change" [disabled]="!(userPermissions | async).ofwca.regional_change"  mat-menu-item (click)="generateSurgeReport()">Raport Przepięć OFWCA</button>
      <button *ngIf="(userPermissions | async).ofwca.read_report" [disabled]="!(userPermissions | async).ofwca.read_report"  mat-menu-item (click)="generateSignedContractWithTheEmployeeReport()">Raport umów z pracownikiem</button>
    </mat-menu>
    <button *ngIf="(userPermissions | async).ofwca.read_report && rejectedCommission" (click)="downloadRejectedCommissionReport()" [disabled]="!(userPermissions | async).ofwca.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="ofwcas" matSort (matSortChange)="sortChanged($event)">

    <!-- Position Column -->
    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="fullNameReversed"> Imię i nazwisko</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.uuid]">
          {{element.firstName}} {{element.lastName}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="pesel">
      <th mat-header-cell *matHeaderCellDef> PESEL</th>
      <td mat-cell *matCellDef="let element">
        <ng-container>
          {{element.pesel}}
        </ng-container>
        <ng-container *ngIf="!(userPermissions | async).ofwca.read">
          <span class="limited-access"><mat-icon matTooltip="Brak dostępu do danych" matTooltipPosition="above">do_not_disturb</mat-icon></span>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email</th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let email of element.emails">
          <span *ngIf="email.main ">{{email.address}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Numer telefonu</th>
      <td mat-cell *matCellDef="let element">
        {{element.phone | phone}}
      </td>
    </ng-container>

    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef> Placówka</th>
      <td mat-cell *matCellDef="let element">
        <app-table-address *ngIf="element.facility" [address]="element.facility.address"></app-table-address>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
      <td mat-cell *matCellDef="let element">
        {{element.assetsRegional?.firstName}} {{element.assetsRegional?.lastName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="rau">
      <th mat-header-cell *matHeaderCellDef> RAU</th>
      <td mat-cell *matCellDef="let element">
        <mat-chip-list>
          <ng-container *ngFor="let rauNumber of element.rauNumbers;">
            <mat-chip  color="accent" selected>{{rauNumber.rau}}</mat-chip>
          </ng-container>
        </mat-chip-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="actionsRejectedCommission">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).ofwca.delete" mat-menu-item (click)="deleteRejectedCommission(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).ofwca.delete" mat-menu-item (click)="deleteOfwca(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
